import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  preparePapAffiliateInBrowserUrl,
  trackPostAffiliateClick,
} from "../utils/postAffiliatePro";

const PapAffiliateTracker = () => {
  const location = useLocation();

  useEffect(() => {
    preparePapAffiliateInBrowserUrl();
    trackPostAffiliateClick();
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default PapAffiliateTracker;
